import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import commonNetwork from "../../common/api/commonNetwork"; 
import { FetchResultType } from "../fetchTypes";
export const getEmailSmsPackage = createAsyncThunk(
  "/package/emailSmsPackage",
  async (params:any, { rejectWithValue }) => {
    try {
      const { data, errorMessage, isSuccess } = await commonNetwork.get("/package/GetTotalEmailSms",params);
      if (isSuccess ) {
        return data.data;
      } else {
        return rejectWithValue(data);
      }
    } catch (e:any) {
      return rejectWithValue(e.data.message);
    }
  }
);

export type EmailSmsPackage ={
  totalEmail:number,
  totalSMS:number,
  totalWhatsapp:number
}

export interface EmailSmsPackageStateType extends FetchResultType {
  emailSmsPackage: EmailSmsPackage,
}

export const emailSmsPackageSlice = createSlice({
  name: "emailSmsPackageSlice",
  initialState: {
    emailSmsPackage: [],
    isFetching: false,
    isSuccess: false,
    isError: false,
    errorMessage: "",
  },
  reducers: {
    clearState: (state) => {
      state.emailSmsPackage = [];
      state.isFetching = false;
      state.isSuccess = false;
      state.isError = false;
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getEmailSmsPackage.fulfilled, (state, { payload }) => {
      state.emailSmsPackage = payload;
      state.isFetching = false;
      state.isSuccess = true;
      state.isError = false;
      return state;
    });
    builder.addCase(getEmailSmsPackage.rejected, (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
    });
    builder.addCase(getEmailSmsPackage.pending, (state) => {
      state.isFetching = true;
    });
  },
});
export const { clearState } = emailSmsPackageSlice.actions;

export const emailSmsPackageSelector = (state:any) => state.emailSmsPackage;

export const emailSmsPackageReducer = emailSmsPackageSlice.reducer;
